export default __webpack_public_path__ + "static/media/6.bc998065.png";